<template>
  <v-main>
    <v-container fluid>
      <!-- Statistics Cards -->
      <v-row class="mb-4" v-if="statistics">
        <v-col cols="12" sm="6" lg="3">
          <v-card elevation="6" rounded="xxl" color="primary" dark>
            <v-card-text class="pa-3 pa-sm-4">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <p class="text-h5 text-sm-h4 font-weight-bold mb-1">{{ statistics.total_requests }}</p>
                  <p class="text-caption text-sm-subtitle-1">Total Requests</p>
                </div>
                <v-icon :size="$vuetify.breakpoint.xsOnly ? 30 : 40">mdi-file-document-multiple</v-icon>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <v-card elevation="6" rounded="xxl" color="warning" dark>
            <v-card-text class="pa-3 pa-sm-4">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <p class="text-h5 text-sm-h4 font-weight-bold mb-1">{{ statistics.pending_requests }}</p>
                  <p class="text-caption text-sm-subtitle-1">Pending</p>
                </div>
                <v-icon :size="$vuetify.breakpoint.xsOnly ? 30 : 40">mdi-clock-outline</v-icon>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <v-card elevation="6" rounded="xxl" color="success" dark>
            <v-card-text class="pa-3 pa-sm-4">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <p class="text-h5 text-sm-h4 font-weight-bold mb-1">{{ statistics.approved_requests }}</p>
                  <p class="text-caption text-sm-subtitle-1">Approved</p>
                </div>
                <v-icon :size="$vuetify.breakpoint.xsOnly ? 30 : 40">mdi-check-circle</v-icon>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="12" sm="6" lg="3">
          <v-card elevation="6" rounded="xxl" color="info" dark>
            <v-card-text class="pa-3 pa-sm-4">
              <div class="d-flex align-center justify-space-between">
                <div>
                  <p class="text-h5 text-sm-h4 font-weight-bold mb-1">₹{{ statistics.total_refunds }}</p>
                  <p class="text-caption text-sm-subtitle-1">Total Refunds</p>
                </div>
                <v-icon :size="$vuetify.breakpoint.xsOnly ? 30 : 40">mdi-cash-refund</v-icon>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Filters Card -->
      <v-row>
        <v-col cols="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title class="text-h6 text-sm-h5 font-weight-bold">
              {{ isDeletePage() != true ? 'Walk Reschedule Requests' : 'Deleted Reschedule Requests' }}
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-text-field
                    solo
                    rounded
                    dense
                    v-model="filter.search_keyword"
                    label="Search customer, reason..."
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="(filter.search_keyword = null), (page = 1), getData()"
                    @keydown.enter="(page = 1), getData()"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <v-autocomplete
                    solo
                    dense
                    hide-details="auto"
                    rounded
                    v-model="filter.request_type"
                    :items="requestTypes"
                    label="Request Type"
                    @click:clear="(filter.request_type = null), (page = 1)"
                    @input="(page = 1), getData()"
                    placeholder="All Types"
                    prepend-inner-icon="mdi-swap-horizontal"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <v-autocomplete
                    solo
                    dense
                    hide-details="auto"
                    rounded
                    v-model="filter.status"
                    :items="statusOptions"
                    label="Status"
                    @click:clear="(filter.status = null), (page = 1)"
                    @input="(page = 1), getData()"
                    placeholder="All Status"
                    prepend-inner-icon="mdi-toggle-switch"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="2">
                  <v-autocomplete
                    solo
                    dense
                    hide-details="auto"
                    rounded
                    v-model="filter.refund_eligibility"
                    :items="refundOptions"
                    label="Refund Status"
                    @click:clear="(filter.refund_eligibility = null), (page = 1)"
                    @input="(page = 1), getData()"
                    placeholder="All"
                    prepend-inner-icon="mdi-cash"
                    clearable
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4" lg="3">
                  <v-menu
                    v-model="fromDateMenu"
                    :close-on-content-click="false"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="filter.from_date"
                        label="From Date"
                        prepend-inner-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        solo
                        dense
                        rounded
                        hide-details="auto"
                        clearable
                        @click:clear="(filter.from_date = null), getData()"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="filter.from_date"
                      @input="fromDateMenu = false, getData()"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Data Table -->
      <v-row>
        <v-col cols="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="min-height: 300px">
                <v-progress-linear indeterminate color="primary"></v-progress-linear>
              </section>
              
              <!-- Mobile Card View -->
              <div v-else-if="$vuetify.breakpoint.smAndDown && walkRequests.length > 0">
                <v-card
                  v-for="(request, i) in walkRequests"
                  :key="`mobile-request-${i}`"
                  class="mb-3"
                  outlined
                  rounded="lg"
                >
                  <v-card-text class="pa-3">
                    <div class="d-flex justify-space-between align-start mb-2">
                      <div>
                        <v-chip
                          :color="request.request_type === 'reschedule' ? 'info' : 'error'"
                          text-color="white"
                          small
                          class="mb-1"
                        >
                          {{ request.request_type === 'reschedule' ? 'Reschedule' : 'Cancellation' }}
                        </v-chip>
                        <v-chip
                          :color="request.status === 'pending' ? 'warning' : request.status === 'approved' ? 'success' : 'error'"
                          text-color="white"
                          small
                          class="ml-1 mb-1"
                        >
                          {{ request.status }}
                        </v-chip>
                      </div>
                      <div>
                        <v-menu offset-y>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              icon
                              v-bind="attrs"
                              v-on="on"
                            >
                              <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                          </template>
                          <v-list dense>
                            <v-list-item @click="viewDetails(request)">
                              <v-list-item-icon>
                                <v-icon small>mdi-eye</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>View Details</v-list-item-title>
                            </v-list-item>
                            <v-list-item 
                              v-if="request.status === 'pending' && request.request_type === 'reschedule'"
                              @click="openApproveDialog(request)"
                            >
                              <v-list-item-icon>
                                <v-icon small color="success">mdi-check</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Approve</v-list-item-title>
                            </v-list-item>
                            <v-list-item 
                              v-if="request.status === 'pending'"
                              @click="openRejectDialog(request)"
                            >
                              <v-list-item-icon>
                                <v-icon small color="error">mdi-close</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Reject</v-list-item-title>
                            </v-list-item>
                            <v-list-item 
                              v-if="!isDeletePage()"
                              @click="openDeleteDialog(request.id)"
                            >
                              <v-list-item-icon>
                                <v-icon small color="error">mdi-delete</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Delete</v-list-item-title>
                            </v-list-item>
                            <v-list-item 
                              v-else
                              @click="restoreRequest(request.id)"
                            >
                              <v-list-item-icon>
                                <v-icon small color="success">mdi-delete-restore</v-icon>
                              </v-list-item-icon>
                              <v-list-item-title>Restore</v-list-item-title>
                            </v-list-item>
                          </v-list>
                        </v-menu>
                      </div>
                    </div>
                    
                    <div class="text-body-2 font-weight-bold mb-1" v-if="request.user">
                      {{ request.user.first_name }} {{ request.user.last_name }}
                    </div>
                    <div class="text-caption text--secondary mb-2" v-if="request.user">
                      {{ request.user.phone || request.user.email }}
                    </div>
                    
                    <v-divider class="my-2"></v-divider>
                    
                    <div class="text-caption">
                      <div class="d-flex justify-space-between mb-1">
                        <span class="text--secondary">Original Date:</span>
                        <span v-if="request.walk && request.walk.daily_job_plan">
                          {{ formatDate(request.walk.daily_job_plan.date) }}
                        </span>
                        <span v-else>-</span>
                      </div>
                      <div class="d-flex justify-space-between mb-1">
                        <span class="text--secondary">Time:</span>
                        <span>{{ request.walk ? request.walk.timeslot : '-' }}</span>
                      </div>
                      <div v-if="request.request_type === 'reschedule'" class="d-flex justify-space-between mb-1">
                        <span class="text--secondary">New Date:</span>
                        <span>{{ request.new_date ? formatDate(request.new_date) : '-' }}</span>
                      </div>
                      <div v-if="request.request_type === 'reschedule'" class="d-flex justify-space-between mb-1">
                        <span class="text--secondary">New Time:</span>
                        <span>{{ request.new_timeslot || '-' }}</span>
                      </div>
                      <div class="d-flex justify-space-between mb-1">
                        <span class="text--secondary">Refund:</span>
                        <v-chip v-if="request.refund_eligibility" color="success" x-small text-color="white">
                          ₹{{ request.refund_amount }}
                        </v-chip>
                        <v-chip v-else color="grey" x-small text-color="white">
                          No Refund
                        </v-chip>
                      </div>
                      <div class="mt-2" v-if="request.reason">
                        <span class="text--secondary">Reason:</span>
                        <div class="text-caption mt-1">{{ request.reason }}</div>
                      </div>
                    </div>
                  </v-card-text>
                </v-card>
                
                <div v-if="walkRequests.length === 0" class="text-center py-8">
                  <p class="text-h6 text--secondary">No requests found</p>
                </div>
              </div>
              
              <!-- Desktop Table View -->
              <v-simple-table v-else-if="!$vuetify.breakpoint.smAndDown" fixed-header height="400" class="striped-table">
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Request Type</th>
                      <th class="text-left">Status</th>
                      <th class="text-left">Customer</th>
                      <th class="text-left">Pet Name</th>
                      <th class="text-left">Original Date</th>
                      <th class="text-left">Original Time</th>
                      <th class="text-left">New Date</th>
                      <th class="text-left">New Time</th>
                      <th class="text-left">Reason</th>
                      <th class="text-left">Hours Before</th>
                      <th class="text-left">Refund</th>
                      <th class="text-left">Requested On</th>
                      <th class="text-left" style="min-width: 160px">
                        Created At
                      </th>
                      <th class="text-right action_th">Action</th>
                    </tr>
                  </thead>
                  <tbody v-if="walkRequests.length != 0">
                    <tr
                      v-for="(request, i) in walkRequests"
                      :key="`request_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': walkRequests.length - 1 == i,
                      }"
                    >
                      <td>{{ (page - 1) * rowsPerPage + i + 1 }}</td>
                      <td>
                        <v-chip
                          :color="request.request_type === 'reschedule' ? 'info' : 'error'"
                          text-color="white"
                          small
                        >
                          <v-icon left small>
                            {{ request.request_type === 'reschedule' ? 'mdi-calendar-refresh' : 'mdi-cancel' }}
                          </v-icon>
                          {{ request.request_type === 'reschedule' ? 'Reschedule' : 'Cancellation' }}
                        </v-chip>
                      </td>
                      <td>
                        <v-tooltip bottom v-if="request.status === 'pending'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip v-bind="attrs" v-on="on" small color="warning" text-color="white">
                              <v-avatar left>
                                <v-icon size="15">mdi-clock-outline</v-icon>
                              </v-avatar>
                              Pending
                            </v-chip>
                          </template>
                          <span>Waiting for approval</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="request.status === 'approved'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip v-bind="attrs" v-on="on" small color="success" text-color="white">
                              <v-avatar left>
                                <v-icon size="15">mdi-check-circle</v-icon>
                              </v-avatar>
                              Approved
                            </v-chip>
                          </template>
                          <span>Request has been approved</span>
                        </v-tooltip>
                        <v-tooltip bottom v-if="request.status === 'rejected'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-chip v-bind="attrs" v-on="on" small color="error" text-color="white">
                              <v-avatar left>
                                <v-icon size="15">mdi-close-circle</v-icon>
                              </v-avatar>
                              Rejected
                            </v-chip>
                          </template>
                          <span>Request has been rejected</span>
                        </v-tooltip>
                      </td>
                      <td>
                        <template v-if="request.user">
                          {{ request.user.first_name }} {{ request.user.last_name }}
                          <br>
                          <small class="text--secondary">{{ request.user.phone || request.user.email }}</small>
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <template v-if="request.walk && request.walk.daily_job_plan && request.walk.daily_job_plan.user_pet">
                          {{ request.walk.daily_job_plan.user_pet.name }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <template v-if="request.walk && request.walk.daily_job_plan">
                          {{ formatDate(request.walk.daily_job_plan.date) }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <template v-if="request.walk">
                          {{ request.walk.timeslot }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <template v-if="request.request_type === 'reschedule' && request.new_date">
                          {{ formatDate(request.new_date) }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td>
                        <template v-if="request.request_type === 'reschedule' && request.new_timeslot">
                          {{ request.new_timeslot }}
                        </template>
                        <template v-else>-</template>
                      </td>
                      <td style="min-width: 200px">
                        <template v-if="request.reason && request.reason.length > 30">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <span v-bind="attrs" v-on="on">
                                {{ request.reason.slice(0, 30) + "..." }}
                              </span>
                            </template>
                            <span>{{ request.reason }}</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          {{ request.reason || '-' }}
                        </template>
                      </td>
                      <td>
                        <v-chip :color="request.hours_before_walk >= 24 ? 'success' : 'error'" x-small text-color="white">
                          {{ request.hours_before_walk }}h
                        </v-chip>
                      </td>
                      <td>
                        <template v-if="request.refund_eligibility">
                          <v-chip color="success" x-small text-color="white">
                            ₹{{ request.refund_amount }}
                          </v-chip>
                        </template>
                        <template v-else>
                          <v-chip color="grey" x-small text-color="white">
                            No Refund
                          </v-chip>
                        </template>
                      </td>
                      <td>{{ formatDateTime(request.requested_at) }}</td>
                      <td style="min-width: 160px">
                        {{ formatDateTime(request.created_at) }}
                      </td>
                      <td class="text-right" style="min-width: 200px">
                        <!-- View Details -->
                        <v-tooltip bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              class="my-auto"
                              color="info"
                              @click="viewDetails(request)"
                            >
                              <v-icon dark>mdi-eye</v-icon>
                            </v-btn>
                          </template>
                          <span>View Details</span>
                        </v-tooltip>

                        <!-- Approve (only for pending reschedule requests) -->
                        <v-tooltip bottom v-if="request.status === 'pending' && request.request_type === 'reschedule'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              class="my-auto ml-2"
                              color="success"
                              @click="openApproveDialog(request)"
                            >
                              <v-icon dark>mdi-check</v-icon>
                            </v-btn>
                          </template>
                          <span>Approve Request</span>
                        </v-tooltip>

                        <!-- Reject (only for pending requests) -->
                        <v-tooltip bottom v-if="request.status === 'pending'">
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              v-bind="attrs"
                              v-on="on"
                              fab
                              x-small
                              class="my-auto ml-2"
                              color="error"
                              @click="openRejectDialog(request)"
                            >
                              <v-icon dark>mdi-close</v-icon>
                            </v-btn>
                          </template>
                          <span>Reject Request</span>
                        </v-tooltip>

                        <!-- Delete -->
                        <template v-if="isDeletePage() != true">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'walk_reschedule_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-2"
                                color="error"
                                @click="openDeleteDialog(request.id)"
                              >
                                <v-icon dark>mdi-delete</v-icon>
                              </v-btn>
                            </template>
                            <span>Delete Request</span>
                          </v-tooltip>
                        </template>
                        <template v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn v-can:delete="'walk_reschedule_requests'"
                                v-bind="attrs"
                                v-on="on"
                                fab
                                x-small
                                class="my-auto ml-2"
                                color="success"
                                @click="restoreRequest(request.id)"
                              >
                                <v-icon dark>mdi-delete-restore</v-icon>
                              </v-btn>
                            </template>
                            <span>Restore Request</span>
                          </v-tooltip>
                        </template>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No requests found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              
              <!-- Empty State for all views -->
              <div v-else class="text-center py-8">
                <v-icon size="64" color="grey lighten-1">mdi-file-document-outline</v-icon>
                <p class="text-h6 text--secondary mt-3">No requests found</p>
                <p class="text-body-2 text--secondary">Customer walk requests will appear here</p>
              </div>
              <v-pagination rounded v-model="page" :length="paginationLength"></v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Details Dialog -->
      <v-dialog v-model="showDetailsDialog" :width="$vuetify.breakpoint.smAndDown ? '100%' : '800'" :fullscreen="$vuetify.breakpoint.xsOnly" persistent>
        <v-card rounded="xxl">
          <v-card-title class="primary white--text">
            <span class="text-h5">Request Details</span>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="showDetailsDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-4 pb-2" v-if="selectedRequest" :class="{'pa-3': $vuetify.breakpoint.xsOnly}">
            <v-row>
              <v-col cols="12" sm="6">
                <div class="mb-3">
                  <span class="font-weight-bold">Request Type:</span>
                  <v-chip :color="selectedRequest.request_type === 'reschedule' ? 'info' : 'error'" small class="ml-2" text-color="white">
                    {{ selectedRequest.request_type === 'reschedule' ? 'Reschedule' : 'Cancellation' }}
                  </v-chip>
                </div>
                <div class="mb-3">
                  <span class="font-weight-bold">Status:</span>
                  <v-chip 
                    :color="selectedRequest.status === 'pending' ? 'warning' : selectedRequest.status === 'approved' ? 'success' : 'error'" 
                    small 
                    class="ml-2" 
                    text-color="white"
                  >
                    {{ selectedRequest.status }}
                  </v-chip>
                </div>
                <div class="mb-3">
                  <span class="font-weight-bold">Customer:</span>
                  <span class="ml-2" v-if="selectedRequest.user">
                    {{ selectedRequest.user.first_name }} {{ selectedRequest.user.last_name }}
                    ({{ selectedRequest.user.phone }})
                  </span>
                </div>
                <div class="mb-3" v-if="selectedRequest.walk && selectedRequest.walk.daily_job_plan && selectedRequest.walk.daily_job_plan.user_pet">
                  <span class="font-weight-bold">Pet:</span>
                  <span class="ml-2">{{ selectedRequest.walk.daily_job_plan.user_pet.name }}</span>
                </div>
              </v-col>
              <v-col cols="12" sm="6">
                <div class="mb-3">
                  <span class="font-weight-bold">Original Walk Date:</span>
                  <span class="ml-2" v-if="selectedRequest.walk && selectedRequest.walk.daily_job_plan">
                    {{ formatDate(selectedRequest.walk.daily_job_plan.date) }} at {{ selectedRequest.walk.timeslot }}
                  </span>
                </div>
                <div class="mb-3" v-if="selectedRequest.request_type === 'reschedule'">
                  <span class="font-weight-bold">New Walk Date:</span>
                  <span class="ml-2">
                    {{ formatDate(selectedRequest.new_date) }} at {{ selectedRequest.new_timeslot }}
                  </span>
                </div>
                <div class="mb-3">
                  <span class="font-weight-bold">Hours Before Walk:</span>
                  <v-chip :color="selectedRequest.hours_before_walk >= 24 ? 'success' : 'error'" x-small class="ml-2" text-color="white">
                    {{ selectedRequest.hours_before_walk }} hours
                  </v-chip>
                </div>
                <div class="mb-3">
                  <span class="font-weight-bold">Refund Eligibility:</span>
                  <v-chip :color="selectedRequest.refund_eligibility ? 'success' : 'grey'" x-small class="ml-2" text-color="white">
                    {{ selectedRequest.refund_eligibility ? `₹${selectedRequest.refund_amount}` : 'No Refund' }}
                  </v-chip>
                </div>
              </v-col>
            </v-row>
            
            <v-divider class="my-3"></v-divider>
            
            <div class="mb-3">
              <span class="font-weight-bold">Reason:</span>
              <p class="mt-2">{{ selectedRequest.reason || 'No reason provided' }}</p>
            </div>
            
            <div class="mb-3" v-if="selectedRequest.admin_remarks">
              <span class="font-weight-bold">Admin Remarks:</span>
              <p class="mt-2">{{ selectedRequest.admin_remarks }}</p>
            </div>
            
            <div class="mb-3" v-if="selectedRequest.processed_by">
              <span class="font-weight-bold">Processed By:</span>
              <span class="ml-2">
                {{ selectedRequest.processed_by.first_name }} {{ selectedRequest.processed_by.last_name }}
                on {{ formatDateTime(selectedRequest.processed_at) }}
              </span>
            </div>

            <div v-if="rescheduleInfo" class="mb-3">
              <v-alert type="info" outlined>
                <strong>Reschedule Quota:</strong> 
                {{ rescheduleInfo.reschedules_used }} of {{ rescheduleInfo.current_quota }} used
                ({{ rescheduleInfo.remaining }} remaining)
              </v-alert>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="showDetailsDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Approve Dialog -->
      <v-dialog v-model="showApproveDialog" :width="$vuetify.breakpoint.xsOnly ? '100%' : '500'" persistent>
        <v-card :rounded="$vuetify.breakpoint.xsOnly ? 'lg' : 'xxl'">
          <v-card-title class="success white--text">
            <span class="text-h5">Approve Reschedule Request</span>
          </v-card-title>
          <v-card-text class="pt-4">
            <p>Are you sure you want to approve this reschedule request?</p>
            <p class="mt-2" v-if="selectedRequest">
              <strong>Customer:</strong> {{ selectedRequest.user?.first_name }} {{ selectedRequest.user?.last_name }}<br>
              <strong>From:</strong> {{ formatDate(selectedRequest.walk?.daily_job_plan?.date) }} at {{ selectedRequest.walk?.timeslot }}<br>
              <strong>To:</strong> {{ formatDate(selectedRequest.new_date) }} at {{ selectedRequest.new_timeslot }}
            </p>
            <v-textarea
              v-model="adminRemarks"
              label="Admin Remarks (Optional)"
              outlined
              rows="3"
              class="mt-4"
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="showApproveDialog = false, adminRemarks = ''">Cancel</v-btn>
            <v-btn v-can:edit="'walk_reschedule_requests'" color="success" @click="approveRequest" :loading="isProcessing">Approve</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Reject Dialog -->
      <v-dialog v-model="showRejectDialog" :width="$vuetify.breakpoint.xsOnly ? '100%' : '500'" persistent>
        <v-card :rounded="$vuetify.breakpoint.xsOnly ? 'lg' : 'xxl'">
          <v-card-title class="error white--text">
            <span class="text-h5">Reject Request</span>
          </v-card-title>
          <v-card-text class="pt-4">
            <p>Are you sure you want to reject this request?</p>
            <p class="mt-2" v-if="selectedRequest">
              <strong>Customer:</strong> {{ selectedRequest.user?.first_name }} {{ selectedRequest.user?.last_name }}<br>
              <strong>Type:</strong> {{ selectedRequest.request_type === 'reschedule' ? 'Reschedule' : 'Cancellation' }}
            </p>
            <v-textarea
              v-model="adminRemarks"
              label="Reason for Rejection (Required)"
              outlined
              rows="3"
              class="mt-4"
              :error-messages="rejectError"
              required
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey" text @click="showRejectDialog = false, adminRemarks = '', rejectError = ''">Cancel</v-btn>
            <v-btn v-can:edit="'walk_reschedule_requests'" color="error" @click="rejectRequest" :loading="isProcessing">Reject</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Delete Dialog -->
      <v-dialog v-model="deleteDialog" :width="$vuetify.breakpoint.xsOnly ? '90%' : '550px'">
        <v-card :rounded="$vuetify.breakpoint.xsOnly ? 'lg' : 'xxl'">
          <v-container>
            <v-row align="center">
              <v-col sm="3">
                <v-icon large style="color: red; font-size: 90px; width: 150px">
                  mdi-delete-alert
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: red">Warning!</h1>
                      <br />
                      <h3>Are you sure you want to delete this request?</h3>
                      <br />
                      <v-btn color="grey" dark @click="deleteDialog = false">Cancel</v-btn>
                      <v-btn v-can:delete="'walk_reschedule_requests'" color="red" dark class="ml-5" @click="deleteRequest(), (deleteDialog = false)">Delete</v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>

      <!-- Success Dialog -->
      <v-dialog v-model="successDialog" :width="$vuetify.breakpoint.xsOnly ? '90%' : '600'">
        <v-card :rounded="$vuetify.breakpoint.xsOnly ? 'lg' : 'xxl'">
          <v-container>
            <v-row align="center">
              <v-col sm="3" align="center">
                <v-icon large style="color: green; font-size: 90px; width: 200px !important">
                  mdi-check-circle
                </v-icon>
              </v-col>
              <v-col sm="9" align="center">
                <v-card-text>
                  <v-row>
                    <v-col>
                      <h1 style="color: green">Success!</h1>
                      <br />
                      <h3>{{ successMessage }}</h3>
                      <br />
                      <v-btn color="success" @click="successDialog = false">OK</v-btn>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";

export default {
  name: "CustomerWalkRequestsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
        request_type: null,
        status: null,
        refund_eligibility: null,
        from_date: null,
        to_date: null,
      },
      walkRequests: [],
      statistics: null,
      selectedRequest: null,
      rescheduleInfo: null,
      adminRemarks: "",
      rejectError: "",
      
      // UI State
      page: 1,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      isProcessing: false,
      fromDateMenu: false,
      
      // Dialogs
      showDetailsDialog: false,
      showApproveDialog: false,
      showRejectDialog: false,
      deleteDialog: false,
      successDialog: false,
      successMessage: "",
      toBeDeletedId: null,
      
      // Options
      requestTypes: [
        { text: "Reschedule", value: "reschedule" },
        { text: "Cancellation", value: "cancel" },
      ],
      statusOptions: [
        { text: "Pending", value: "pending" },
        { text: "Approved", value: "approved" },
        { text: "Rejected", value: "rejected" },
      ],
      refundOptions: [
        { text: "Eligible", value: "1" },
        { text: "Not Eligible", value: "0" },
      ],
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
    this.getStatistics();
  },
  methods: {
    async getData() {
      this.filter.show_deleted = this.$route.query.open_trash ? 1 : 0;
      this.isLoading = true;
      
      const params = {
        page: this.page,
        rowsPerPage: this.rowsPerPage,
        show_deleted: this.filter.show_deleted,
        search_keyword: this.filter.search_keyword || "",
        request_type: this.filter.request_type || "",
        status: this.filter.status || "",
        refund_eligibility: this.filter.refund_eligibility || "",
        from_date: this.filter.from_date || "",
        to_date: this.filter.to_date || "",
      };
      
      try {
        const response = await axios.get('customer_walk_requests', { params });
        console.log('API Response:', response.data); // Debug log
        this.walkRequests = response.data.data || [];
        this.count = response.data.count || 0;
        this.paginationLength = Math.ceil(this.count / this.rowsPerPage);
      } catch (error) {
        console.error('Error fetching customer walk requests:', error);
        if (error.response) {
          console.error('Response data:', error.response.data);
          console.error('Response status:', error.response.status);
        }
        this.isUnAuthorised();
      } finally {
        this.isLoading = false;
      }
    },
    
    async getStatistics() {
      try {
        const response = await axios.get('customer_walk_requests/statistics');
        this.statistics = response.data.data;
      } catch (error) {
        console.error(error);
      }
    },
    
    async viewDetails(request) {
      this.selectedRequest = request;
      this.showDetailsDialog = true;
      
      // Fetch additional details
      try {
        const response = await axios.get(`customer_walk_requests/${this.encryptIt(request.id)}`);
        this.selectedRequest = response.data.data;
        this.rescheduleInfo = response.data.reschedule_info;
      } catch (error) {
        console.error(error);
      }
    },
    
    openApproveDialog(request) {
      this.selectedRequest = request;
      this.adminRemarks = "";
      this.showApproveDialog = true;
    },
    
    openRejectDialog(request) {
      this.selectedRequest = request;
      this.adminRemarks = "";
      this.rejectError = "";
      this.showRejectDialog = true;
    },
    
    async approveRequest() {
      if (!this.selectedRequest) return;
      
      this.isProcessing = true;
      try {
        await axios.post(`customer_walk_requests/${this.encryptIt(this.selectedRequest.id)}/approve`, {
          admin_remarks: this.adminRemarks,
        });
        
        this.showApproveDialog = false;
        this.successMessage = "Reschedule request approved successfully!";
        this.successDialog = true;
        this.adminRemarks = "";
        this.getData();
        this.getStatistics();
      } catch (error) {
        console.error(error);
        alert("Error approving request: " + (error.response?.data?.message || error.message));
      } finally {
        this.isProcessing = false;
      }
    },
    
    async rejectRequest() {
      if (!this.selectedRequest) return;
      
      if (!this.adminRemarks.trim()) {
        this.rejectError = "Reason is required for rejection";
        return;
      }
      
      this.isProcessing = true;
      try {
        await axios.post(`customer_walk_requests/${this.encryptIt(this.selectedRequest.id)}/reject`, {
          admin_remarks: this.adminRemarks,
        });
        
        this.showRejectDialog = false;
        this.successMessage = "Request rejected successfully!";
        this.successDialog = true;
        this.adminRemarks = "";
        this.rejectError = "";
        this.getData();
        this.getStatistics();
      } catch (error) {
        console.error(error);
        alert("Error rejecting request: " + (error.response?.data?.message || error.message));
      } finally {
        this.isProcessing = false;
      }
    },
    
    openDeleteDialog(id) {
      this.toBeDeletedId = id;
      this.deleteDialog = true;
    },
    
    async deleteRequest() {
      if (!this.toBeDeletedId) return;
      
      try {
        await axios.post(`customer_walk_requests/clear/${this.encryptIt(this.toBeDeletedId)}`);
        this.successMessage = "Request deleted successfully!";
        this.successDialog = true;
        this.getData();
        this.getStatistics();
      } catch (error) {
        console.error(error);
        this.isUnAuthorised();
      }
    },
    
    async restoreRequest(id) {
      try {
        await axios.post(`customer_walk_requests/restore/${this.encryptIt(id)}`);
        this.successMessage = "Request restored successfully!";
        this.successDialog = true;
        this.getData();
      } catch (error) {
        console.error(error);
        this.isUnAuthorised();
      }
    },
    
    formatDate(date) {
      if (!date) return '-';
      const d = new Date(date);
      return d.toLocaleDateString('en-IN', { day: '2-digit', month: 'short', year: 'numeric' });
    },
    
    formatDateTime(date) {
      if (!date) return '-';
      const d = new Date(date);
      return d.toLocaleDateString('en-IN', { 
        day: '2-digit', 
        month: 'short', 
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
  },
};
</script>

<style scoped>
.striped-table tbody tr:nth-of-type(odd) {
  background-color: rgba(0, 0, 0, 0.02);
}

.table-row-even {
  background-color: #f5f5f5;
}

.table-row-odd {
  background-color: #ffffff;
}

.table-row-last {
  border-bottom: 2px solid #e0e0e0;
}

/* Responsive table styles */
@media (max-width: 1264px) {
  .v-simple-table {
    overflow-x: auto;
  }
  
  .v-simple-table table {
    min-width: 1200px;
  }
}

/* Mobile card styles */
@media (max-width: 600px) {
  .v-card__title {
    font-size: 1.1rem !important;
  }
  
  .v-dialog--fullscreen .v-card {
    border-radius: 0 !important;
  }
}

/* Responsive text */
.text-caption {
  line-height: 1.3;
}

/* Action buttons spacing on mobile */
@media (max-width: 960px) {
  .action_th {
    min-width: 120px !important;
  }
}
</style>